module.exports = __webpack_public_path__ + "fonts/3MCircularTT-Bold.c8674491.woff";